/**
 * Admin role configurations.
 */

import { MINIMAL_CALENDAR } from './calendars'
import { RoleConfig } from './types'

/**
 * Practices Admin configuration.
 */
export const PRACTICES_ADMIN: RoleConfig = {
  zendeskWidget: true,
  eligibilityChecker: true,
  paymentHistory: true,
  requestPayment: true,
  inProductCalendar: MINIMAL_CALENDAR,
}

/**
 * Payments Admin configuration.
 */
export const PAYMENTS_ADMIN: RoleConfig = {
  zendeskWidget: false,
  allSessionTypes: true,
  eligibilityChecker: true,
  paymentHistory: true,
  inProductCalendar: MINIMAL_CALENDAR,
}

/**
 * Providers Admin configuration.
 */
export const PROVIDERS_ADMIN: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: true,
  inProductCalendar: MINIMAL_CALENDAR,
}

/**
 * NP Admin configuration.
 * Access to the hidden admin/np-program tooling (e.g. bulk uploads).
 */
export const NP_ADMIN: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: false,
  inProductCalendar: MINIMAL_CALENDAR,
}

/**
 * View Only configuration.
 */
export const VIEW_ONLY: RoleConfig = {
  zendeskWidget: false,
  eligibilityChecker: false,
  inProductCalendar: MINIMAL_CALENDAR,
}
